import React from 'react';
import { Box, Container, Typography, Button, Stack } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  handleReload = () => {
    window.location.href = '/';
  };

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display='flex'
          flexDirection='column'
          height='100vh'
          textAlign='center'
          justifyContent='center'
          sx={{ backgroundColor: '#e4f5ff' }}
        >
          <Container maxWidth='sm'>
            <ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
            <Typography variant='h2' gutterBottom>
              Algo salió mal
            </Typography>
            <Typography variant='body1' color='text.secondary' sx={{ mb: 4 }}>
              Ocurrió un error inesperado. Puedes intentar de nuevo o volver al inicio.
            </Typography>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <Typography
                variant='caption'
                component='pre'
                sx={{
                  mb: 3,
                  p: 2,
                  backgroundColor: 'grey.100',
                  borderRadius: 1,
                  textAlign: 'left',
                  overflow: 'auto',
                  maxHeight: 200,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {this.state.error.toString()}
              </Typography>
            )}
            <Stack direction='row' spacing={2} justifyContent='center'>
              <Button
                variant='outlined'
                color='primary'
                onClick={this.handleRetry}
                disableElevation
              >
                Reintentar
              </Button>
              <Button
                variant='contained'
                color='primary'
                onClick={this.handleReload}
                disableElevation
              >
                Ir al Inicio
              </Button>
            </Stack>
          </Container>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
